/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowDownLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-down-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1133.3333333333333 680L1053.4333333333334 759.9L736.6666666666666 443.7V1133.3333333333333H623.3333333333333V443.7L307.1333333333334 760.4666666666666L226.6666666666667 680L680 226.6666666666668L1133.3333333333333 680z" : "M906.6666666666669 544L842.7466666666667 607.92L589.3333333333334 354.9599999999999V906.6666666666666H498.6666666666667V354.9599999999999L245.7066666666667 608.3733333333332L181.3333333333334 544L544 181.3333333333333L906.6666666666669 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowDownLg.displayName = `Blueprint5.Icon.ArrowDownLg`;
export default ArrowDownLg;
